﻿(function () {
    'use strict';
    var serviceId = 'authInterceptorService';

    angular.module('app.services').factory(serviceId, ['$q', '$injector', '$location', 'localStorageService', 'logger', '$rootScope', 'httpBuffer', 'config',
        function ($q, $injector, $location, localStorageService, logger, $rootScope, httpBuffer, config) {

            var authInterceptorServiceFactory = {};

            var request = function (config) {
                config.headers = config.headers || {};
                var authData = localStorageService.get('authorizationData');
                if (authData) {
                    config.headers.Authorization = 'Bearer ' + authData.access_token;
                    config.headers.ModelRequester = authData.ModelRequester ? JSON.stringify(authData.ModelRequester) : null;
                }
                return config;
            };

            var responseError = function (rejection) {
                if (rejection.status === 0) {
                    $rootScope.errorHttp = { status: rejection.status, info: 'Server :' + rejection.config.url };
                } else if (rejection.status === 401) {                    
                    var datacontext = $injector.get('datacontext');
                    var authData = localStorageService.get('authorizationData');
                    if (authData) {
                        if (authData.useRefreshTokens) {
                            $rootScope.errorHttp = { status: rejection.status, info: 'auth' };
                            var deferred = $q.defer();
                            httpBuffer.append(rejection.config, deferred);

                            if (!$rootScope.IsRefreshToken) {
                                $rootScope.$broadcast('event:auth-loginRequired', rejection);
                            }

                            return deferred.promise;
                        } else {
                            $rootScope.errorHttp = { status: rejection.status };
                            datacontext.auth.logOut(true);
                            window.location.reload(true);
                        }
                    } else {
                        $rootScope.errorHttp = { status: rejection.status };
                        datacontext.auth.logOut(true);
                        window.location.reload(true);
                    }
                } else if (rejection.status === 405) {
                    $rootScope.errorHttp = { status: rejection.status, info: rejection.data.message };
                } else if (rejection.status === 500) {
                    $rootScope.errorHttp = { status: rejection.status, info: JSON.stringify(rejection.data) };
                } else {
                    $rootScope.errorHttp = { status: rejection, info: JSON.stringify(rejection.data) };
                }
                return $q.reject(rejection);
            };

            authInterceptorServiceFactory.request = request;
            authInterceptorServiceFactory.responseError = responseError;

            return authInterceptorServiceFactory;
        }]);

})();

